import styled from "styled-components";

export const StyledEntrantInfo = styled.div`
  padding: 40px 48px;
  
  h1{
    font-size: 36px;
    line-height: 42px;
    font-weight: 700;
    color: #2B2B2B;
  }
  
  .style-card{
    background-color: #fff;
    box-shadow: 0px 8px 16px 0px #132D2A14;
    border: 1px solid #E5E5EA;
    border-radius: 4px;
    
    &__header{
      background-color: #FAFAFA;
      padding: 16px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    
    &__body{
      background-color: #FFF;
      padding: 24px;
    }
  }
  
`